export { default } from './svg/on-demand-webinar.svg';
